<ion-grid>
    <ion-row class="ion-justify-content-center">
        <ion-col size="12" size-xs="12" size-sm="12" size-md="6" size-lg="6" size-xl="4">
            <ion-card class="resourcesCard">
                <ion-card-header> </ion-card-header>
                <ion-card-content>
                    <ion-list>
                        <ion-item detail button (click)="downloadImmunizationForm()">
                            <ion-label class="ion-text-wrap">
                                <ion-text>
                                    <h2>
                                        {{ textcontent?.document?.components?.resources?.immunization }}
                                    </h2>
                                </ion-text>
                            </ion-label>
                            <ion-icon color="secondary" slot="end" name="cloud-download"></ion-icon>
                        </ion-item>
                        <ion-item
                            href="{{ document?.url }}"
                            target="_blank"
                            detail
                            button
                            *ngFor="let document of textcontent?.document?.components?.resources?.unpaid"
                        >
                            <ion-label class="ion-text-wrap">
                                <ion-text>
                                    <h2>{{ document?.name }}</h2>
                                    <p>{{ document?.url }}</p>
                                </ion-text>
                            </ion-label>
                            <ion-icon color="secondary" slot="end" name="{{ document?.icon }}"></ion-icon>
                        </ion-item>
                    </ion-list>
                </ion-card-content>
            </ion-card>
        </ion-col>
    </ion-row>
</ion-grid>

<a class="download-zip-link" #downloadZipLink></a>
